module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_010.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_010.png
// module id = 933
// module chunks = 0